import styled from "styled-components";
import { Link } from "../../components/atoms/Link";
import { ExternalLinkIcon } from "../../components/atoms/ExternalLinkIcon";
import {
  firstPartyOffsetPlanTemplate,
  gainScoringManual,
} from "../../lib/constants";

const Container = styled.div`
  display: block;
  font-weight: 300;
`;

function HowToRevegetation() {
  return (
    <Container>
      <p>
        An area of revegetation must be within a woody vegetation type and meet
        the minimum area to perimeter ratio requirements. NVR Map will alert you
        if these requirements are not met.
      </p>
      <p>
        Revegetation must be in accordance with the minimum planting standards
        specified in the{" "}
        <Link
          href={gainScoringManual}
          target="_blank"
          title="Native vegetation gain scoring manual, Version 2"
          rel="noopener noreferrer"
        >
          Native vegetation gain scoring manual, Version 2
        </Link>
        <ExternalLinkIcon />. The first party general offset site management
        plan{" "}
        <Link
          href={firstPartyOffsetPlanTemplate}
          target="_blank"
          title="First party general offset site management plan template"
          rel="noopener noreferrer"
        >
          template
        </Link>
        <ExternalLinkIcon /> on the DEECA website will assist you in meeting
        these standards.
      </p>
      <p>
        An area of revegetation must meet the minimum size and configuration
        requirements:
      </p>
      <ul>
        <li>
          When revegetation is not next to a patch of native vegetation the
          revegetation site must have an area to perimeter ratio of at least 20.
        </li>
        <li>
          When revegetation is next to a patch of native vegetation the combined
          revegetation area and adjacent patch of native vegetation must have an
          area to perimeter ratio of at least 20.
        </li>
      </ul>
      <p>
        The area to perimeter ratio is calculated by dividing the area (metres
        squared) by the perimeter (metres). NVR Map will alert you if the area
        to perimeter ratio of any proposed revegetation area is not adequate.
      </p>
      <p>
        Generally, circular or square areas of more than 0.64 hectares would
        meet the requirements. Long and narrow revegetation sites would not.
      </p>
    </Container>
  );
}

export default HowToRevegetation;
